import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { DateTime } from "luxon";
import { TrajectoryPointDtoVehicleType } from "@/api/generated/models/trajectoryPointDtoVehicleType";
import { Metric } from "@/api/generated/models";
import { buildTileUrl, buildBaseTileFilterParams } from "@/utils/tileUrl";
import { AGGREGATE_METRICS } from "@/utils/metricUtils";
const METRIC_DATA_SOURCES = {
  [Metric.speed]: "get_segments",
  [Metric.acceleration]: "get_segments",
  [Metric.vehicleType]: "get_segments",
  [Metric.averageSpeed]: "get_aggregate_hexagons",
  [Metric.averageAcceleration]: "get_aggregate_hexagons",
  [Metric.density]: "get_aggregate_hexagons"
} satisfies Record<Metric, string>;
const ALL_VEHICLE_TYPES = Object.values(TrajectoryPointDtoVehicleType);
export function useMetricTileUrl(metric, vehicleTypes, timeRange) {
  const $ = _c(5);
  const dataSource = METRIC_DATA_SOURCES[metric];
  const tileVehicleTypes = AGGREGATE_METRICS.has(metric) ? vehicleTypes : ALL_VEHICLE_TYPES;
  let t0;
  if ($[0] !== dataSource || $[1] !== tileVehicleTypes || $[2] !== timeRange.end || $[3] !== timeRange.start) {
    t0 = buildTileUrl(dataSource, buildBaseTileFilterParams({
      vehicleTypes: tileVehicleTypes,
      startTimestamp: timeRange.start,
      endTimestamp: timeRange.end
    }));
    $[0] = dataSource;
    $[1] = tileVehicleTypes;
    $[2] = timeRange.end;
    $[3] = timeRange.start;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
}